import { useEffect, useRef } from "react";
import { useTourContext } from "context/TourContext";
import { useAuth } from "context/AuthContext";
import { daXemTour, danhDauDaXemTour, locBuocCoTarget, chuanHoaBuocTour } from "lib/tourDaXem";
import { trangBiLuongGiu } from "lib/luongTour";
import { BAT_HUONG_DAN } from "lib/batHuongDan";

/**
 * Đăng ký tour cho trang hiện tại.
 * - Tự chạy 1 lần đầu SAU KHI luồng vai trò (nếu có) đã xong, hoặc trang không thuộc luồng.
 * - Khi trang đang bị luồng lần đầu giữ: không đăng ký/auto — useLuongTour lo.
 * - Chạy lại thủ công bằng nút "?" (startActiveTour).
 *
 * @param {string} tourId key ổn định (routes.js hoặc id thủ công như dang-nhap)
 * @param {Array} steps mảng step Joyride; [] = chưa sẵn sàng neo
 */
export default function useTour(tourId, steps) {
  const { registerTour, unregisterTour, startActiveTour, active } = useTourContext();
  const { user, vaiTro, loading: dangTaiAuth } = useAuth();
  const uid = user?.uid ?? null;
  const biLuongGiu = trangBiLuongGiu(vaiTro, uid, tourId);
  const coBuoc = !!(steps && steps.length > 0);
  const chuKyBuoc = coBuoc ? steps.map((b) => `${b.target}|${b.title || ""}`).join("||") : "";
  const stepsRef = useRef(steps);
  stepsRef.current = steps;
  const daChaySessionRef = useRef(false);

  useEffect(() => {
    if (!BAT_HUONG_DAN) return;
    if (active?.tourId === tourId && active?.run && !active?.laLuong) {
      daChaySessionRef.current = true;
    }
  }, [active?.tourId, active?.run, active?.laLuong, tourId]);

  useEffect(() => {
    if (!BAT_HUONG_DAN || biLuongGiu || !coBuoc) return undefined;

    const buocLoc = chuanHoaBuocTour(locBuocCoTarget(stepsRef.current));
    if (!buocLoc.length) return undefined;

    registerTour(tourId, buocLoc, uid, { laLuong: false });

    let henGio;
    if (!dangTaiAuth && !daXemTour(tourId, uid)) {
      henGio = setTimeout(() => startActiveTour(), 450);
    }

    return () => {
      if (henGio) clearTimeout(henGio);
    };
  }, [tourId, chuKyBuoc, coBuoc, biLuongGiu, uid, dangTaiAuth, registerTour, startActiveTour]);

  useEffect(() => {
    if (biLuongGiu) return undefined;

    return () => {
      if (daChaySessionRef.current) {
        danhDauDaXemTour(tourId, uid);
        daChaySessionRef.current = false;
      }
      unregisterTour(tourId);
    };
  }, [tourId, uid, biLuongGiu, unregisterTour]);
}

export { daXemTour, danhDauDaXemTour };
